export default {"src":"/_next/static/media/flag-kr.2cebba99.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};